export enum HubApiMethods {
    SEND_SUPPORT_MESSAGE = 'SendSupportMessage',
    SEND_STAT_EVENT = 'SendStatEvent',
    GET_SERVER_TIME = 'GetServerTime',
    SET_CONSENT_STATE = 'SetConsentState',
    GET_CONSENT_STATE = 'GetConsentState',
    WEB_GUEST_GET_TOKEN = 'WebGuestGetToken',
    GET_TOKEN_EMAIL = 'GetTokenEmail',
    RESET_EMAIL_PASSWORD = 'MobileResetEmailPassword',
    CHANGE_EMAIL_PASSWORD = 'MobileChangeEmailPassword',
    SET_NEW_PASSWORD = 'SetNewPassword',
    GET_MAINTENANCE_DATA = 'GetMaintenanceData',
    GET_LINKED_ACCOUNTS_INFO = 'GetLinkedAccountsInfo',
    ACCEPT_POLICY = 'AcceptPolicy',
    LINK_AUTH_METHOD = 'LinkAuthMethod',
    LINK_AUTH_METHOD_EMAIL = 'LinkAuthMethodEmail',
    LINK_AUTH_METHOD_FB = 'LinkAuthMethodFb',
    LINK_AUTH_METHOD_GOOGLE = 'LinkAuthMethodGoogle',
    LINK_AUTH_METHOD_APPLE_ID = 'LinkAuthMethodAppleId',
    GET_VAT = 'GetVat',
    GET_FEE = 'GetFee',
    GET_TOKEN_BY_MAILING_TOKEN = 'GetTokenByMailingToken',
    CANCEL_REMOVE_ACCOUNT = 'CancelRemoveAccountGdpr',
    REQUEST_EMAIL_OTP_AUTH = 'RequestEmailOtpAuth',
    CONFIRM_EMAIL_OTP_AUTH = 'LoginEmailOtp'
}
